export const config = {
  title: "Hennessy",
  company_logo: "hennessy.png",
  logo_placements: ["Left Chest", "Right Sleeve", "Front Center"],
  show_image_preview: true,
  embroideries: {
    hat: [
      "Cadillac",
      "Cadillac Cursive",
      "Hennessy Automobile",
      "Hennessy Ford",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Lexus",
      "Hennessy Mazda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "JLR",
      "Porsche",
      "Porsche Atlanta NW",
      "Porsche North Atl",
      "Hennessy Vehicle Buying",
    ],
    mens: [
      "Cadillac",
      "Hennessy Automobile",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Lexus",
      "Hennessy Mazda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "JLR",
      "Porsche Atlanta NW",
      "Porsche North Atl",
      "Hennessy Vehicle Buying",
    ],
    womens: [
      "Cadillac",
      "Hennessy Automobile",
      "Hennessy Ford Lincoln",
      "Hennessy Honda",
      "Hennessy Lexus",
      "Hennessy Mazda",
      "Hennessy Mazda GMC",
      "Hennessy Porsche",
      "JLR",
      "Porsche Atlanta NW",
      "Porsche North Atl",
      "Hennessy Vehicle Buying",
    ],
    accessory: [],
    customs: [],
    office: [],
    sales: [],
    service: [],
    detail: [],
    bodyshop: [],
    parts: [],
  },
  email_recipients: [
    "lbudbill@gpcorp.com",
    "lbudbell@comcast.net",
    "zwarner@hennessyauto.com",
    "asarazua@gpcorp.com",
  ],
  stores: [
    {
      name: "Hennessy Cadillac Duluth",
      address: "3377 Satellite Blvd, Duluth, GA 30096",
      code: "HENCDU",
      password: "HennessY",
    },
    {
      name: "Hennessy Ford Lincoln Atlanta",
      address: "5675 Peachtree Industrial Blvd, Atlanta, GA 30341",
      code: "HENFAT",
      password: "HennessY",
    },
    {
      name: "Hennessy Honda Woodstock",
      address: "8931 Highway 92, Woodstock, GA 30189",
      code: "HENHWO",
      password: "HennessY",
    },
    {
      name: "Hennessy Land Rover N ATL",
      address: "1505 Mansell Rd, Alpharetta, GA 30004",
      code: "HENLAL",
      password: "HennessY",
    },
    {
      name: "Hennessy Land Rover Buckhead",
      address: "3040 Piedmont Rd NE, Atlanta, GA 30305",
      code: "HENCAT",
      password: "HennessY",
    },
    {
      name: "Hennessy Land Rover Gwinnett",
      address: "3423 Old Norcross Rd, Duluth, GA 30096",
      code: "HENADU",
      password: "HennessY",
    },
    {
      name: "Hennessy Lexus Atlanta",
      address: "5955 Peachtree Industrial Blvd, Atlanta, GA 30341",
      code: "HENLAT",
      password: "HennessY",
    },
    {
      name: "Hennessy Lexus Duluth",
      address: "3383 Satellite Blvd, Duluth, GA 30096",
      code: "HENLDU",
      password: "HennessY",
    },
    {
      name: "Hennessy Mazda GMC",
      address: "7261 Jonesboro Rd, Morrow, GA 30260",
      code: "HENMMO",
      password: "HennessY",
    },
    {
      name: "Hennessy Porsche Marietta",
      address: "2501 Windy Hill Rd SE, Marietta, GA 30067",
      code: "HENPMA",
      password: "HennessY",
    },
    {
      name: "Hennessy Porsche Roswell",
      address: "990 Mansell Rd, Roswell, GA 30076",
      code: "HENPRO",
      password: "HennessY",
    },
  ],
  bypass_codes: ["HENNES"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Andrew Sarazua", phone: "678-287-1604" },
    { name: "John Boston", phone: "678-287-1601" },
  ],
  route_prefix: "/hennessy",
  paypal_not_supported: true,
  password: "HennessY",
};
